import React, { type FunctionComponent } from 'react'
import { Checkbox } from 'ic-snacks'
import { useDashIntl } from 'intl/intl.hooks'
import { DashLabel } from 'legacy/dash-blocks/dash-label/DashLabel'

interface Props {
  onToggle: () => void
  isSelected: boolean
}

const PrimaryProductsCheckbox: FunctionComponent<Props> = ({ onToggle, isSelected }) => {
  const inputId = 'toggle-primary-products-checkbox'
  const intl = useDashIntl()

  return (
    <Checkbox onChange={onToggle} isSelected={isSelected} id={inputId} data-testid={inputId}>
      <DashLabel
        label={intl.formatMessage({ id: 'aisle.onlyPrimaryProducts' })}
        htmlFor={inputId}
      />
    </Checkbox>
  )
}

export default PrimaryProductsCheckbox
